
import { css } from 'lit';
export default css`
.iframe__wrapper {
  display: block;
  position: relative;
  max-width: 100%;
}

iframe {
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
`;